module.exports = __webpack_public_path__ + "resources/img/gv-oedu@3x.17040b13.png";